export const DELIVERY_LOCATIONS = [
	{ label: 'Prontera North', slug: 'pn' },
	{ label: 'Prontera South', slug: 'ps' },
	{ label: 'Morocc North', slug: 'mn' },
	{ label: 'Morocc South', slug: 'ms' },
];

export const DELIVERY_NPCS = [
	// Pron North
	{ label: 'Forge Master', location: 'pn', map: 'prt_intr02', coords: '175,95' },
	{ label: 'Handyman', location: 'pn', map: 'prt_intr02', coords: '133,97' },
	{ label: 'Master Chef', location: 'pn', map: 'prt_intr02', coords: '173,23' },
	{ label: 'Sister', location: 'pn', map: 'prt_intr02', coords: '30,128' },
	// Pron South
	{ label: 'Bandit', location: 'ps', map: 'prt_intr01', coords: '169,36' },
	{ label: 'Collector', location: 'ps', map: 'prt_intr01', coords: '74,146' },
	{ label: 'Grand Master', location: 'ps', map: 'prt_vilg01', coords: '141,143' },
	{ label: 'Researcher', location: 'ps', map: 'prt_intr01', coords: '82,36' },
	{ label: 'Sage', location: 'ps', map: 'prt_vilg01', coords: '57,90' },
	// Morocc North
	{ label: 'Explorer', location: 'mn', map: 'moc_intr01', coords: '19,66' },
	{ label: 'Mr. Odd Job', location: 'mn', map: 'moc_vilg01', coords: '131,131' },
	{ label: 'Researcher', location: 'mn', map: 'moc_vilg01', coords: '130,106' },
	{ label: 'Trainer', location: 'mn', map: 'moc_intr01', coords: '118,106' },
	{ label: 'Traveler', location: 'mn', map: 'moc_vilg01', coords: '124,167' },
	{ label: 'Worker', location: 'mn', map: 'moc_vilg01', coords: '50,155' },
	{ label: 'Young Man', location: 'mn', map: 'moc_intr01', coords: '147,149' },
	// Morocc South
	{ label: 'Child', location: 'ms', map: 'moc_intr00', coords: '18,25' },
	{ label: 'Young Farmer', location: 'ms', map: 'moc_vilg00', coords: '94,144' },
];
